export default __webpack_public_path__ + "61434d612037f859d1446ac3e4c3fad3.png";